import React from 'react';
import ScrollSnapBox from '../ScrollSnapBox';

const OurVision = ({
  images = [
    'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2944&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1467533003447-e295ff1b0435?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1487887235947-a955ef187fcc?q=80&w=2855&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  ],
//   subtitle = "Our Vision",
  title = "Our Mission",
  highlightText = "Defining New Future.",
  description = "We are committed to helping Australia achieve net-zero emissions by 2050 through:",
  bulletPointsTitle = ["Green Energy Solutions: ", "Empowering Education: ", "Collaborative Action: "],
  bulletPointsContent = ["Practical and impactful innovations.", "Raising awareness about sustainability.", "Partnerships with governments, businesses, and researchers."],
}) => {
  return (
    <ScrollSnapBox>
      {({ inView }) => (
        <div className='my-16 sm:my-20 md:my-24 lg:my-36'>
        <div className="flex flex-col items-center md:flex-row gap-6 px-6 sm:px-8 md:px-10 lg:px-36 ">
          {/* Left side - Stacked Images */}
          <div className="relative w-full md:w-1/2 h-[380px]">
            {images.map((img, index) => (
              <div
                key={index}
                className="absolute transition-all duration-1000"
                style={{
                  transform: inView 
                    ? `translate(${index * 30}px, ${index * 30}px)` 
                    : 'translate(0, 100px)',
                  opacity: inView ? 1 : 0,
                  transitionDelay: `${index * 200}ms`,
                  zIndex: index,
                  width: '85%', 
                  height: '300px',
                }}
              >
                <img
                  src={img}
                  alt={`Duralyze Stacked ${index + 1}`}
                  className="w-full h-full object-cover shadow-lg"
                />
              </div>
            ))}
          </div>

          {/* Right side - Content */}
          <div className="w-full md:w-1/2 space-y-6">
            <div 
              className="transition-all duration-1000"
              style={{
                transform: inView ? 'translateY(0)' : 'translateY(50px)',
                opacity: inView ? 1 : 0,
              }}
            > 
              <div className="font-medium text-2xl md:text-3xl lg:text-4xl text-gray-700 mb-2 md:mb-4">
                {title}
              </div>

              <div className="text-theme-blue text-xl md:text-2xl lg:text-3xl mb-2 md:mb-4">
                {highlightText}
              </div>

              <div className="space-y-2 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-700 mb-2">
                {description}
              </div>

              <div className="space-y-2 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-700">
                <ul className="list-disc pl-8">
                  {bulletPointsTitle.map((title, index) => (
                    <li key={index}>
                      <span className='font-bold'>{title}</span>
                      {bulletPointsContent[index]}
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </div>

        </div>
      )}
    </ScrollSnapBox>
  );
};

export default OurVision;